import React from 'react';
import cn from 'classnames';
import { calculateTaskPosition } from './Utils';
import { TASK_AVAILABILITY_TYPE } from './Constants';

const Booking = ({ booking, onBookingClick, overbooking }) => {
  const { top, height } = calculateTaskPosition({ ...booking, kind: TASK_AVAILABILITY_TYPE });
  const cancelled = booking.status === 'cancelled';
  const reassigned = booking.reassigned_designer && booking.reassigned_designer.id;
  const halfSize = reassigned && overbooking;
  return (
    <div
      className={cn('booking', { '-cancelled': cancelled, '-reassigned': reassigned, '-half': halfSize })}
      style={{ top: `${top}px`, height: `${height - 1}px` }}
      onClick={() => onBookingClick(booking)}
      onMouseDown={e => e.stopPropagation()}
      onMouseMove={e => e.stopPropagation()}
      onMouseUp={e => e.stopPropagation()}
    >
      {`${booking.first_name} ${booking.last_name.charAt(0)}`}
    </div>
  );
};
export default Booking;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/Booking.js